module.exports = __webpack_public_path__ + "img/nedir-05.42c7d4e7.svg";